export const UNAUTHENTICATED_USER = 'UNAUTHENTICATED';

export const roles = {
  admin: 'ADMIN',
  user: 'USER',
};
